import { ButtonComponentConfig } from '..';

export interface NoteComponentAdditionalButtonClickOutput {
    additionalButton: ButtonComponentConfig;
    data?: any;
}
